<template>
	<div>

		<Loader :soft="true" v-if="soft_loading" />

		<Loader v-if="loading" />
		<div v-else>

			<Modal v-if="comments_editor" v-on:close="comments_editor = false;">
				<OrderComments :id="comments_editor" v-on:success="comments_editor = false; load();" />
			</Modal>

			<!-- <button v-on:click="load">Refresh</button> -->

			<Table
				:sortby="false"
				:columns="columns"
				:rows="rows"
				:filters="filters"
        :perpage="100"
        :totalRecords="totalRecords"
				ref="table">
				<template v-slot:filters>
					<div>
						<strong>Country</strong>
					</div>
					<select v-on:change="load" v-model="filter_country">
						<option :value="index" v-for="(country, index) in countries">{{country}}</option>
					</select>
				</template>
			</Table>

		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import OrderComments from '@/components/orders/Comments.vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    soft_loading: false,
    data: [],
    comments_editor: false,
    picking_id: null,
    filter_country: false,
    columns: {
      locale_id: {
        type: 'flag',
        name: 'Country'
      },
      order_id: {
        name: 'Order'
      },
      order_date: {
        name: 'Order date'
      },
      customer_data: {
        name: 'Customer'
      },
      clothing_size: {
        name: 'Size'
      },
      comment: {
        name: 'Comment'
      }
      // age: {},
    },
    totalRecords: 0,
    filters: {
      age: {
        mode: 'number'
      }
    }
  }),
  components: {
    OrderComments
  },
  computed: {
    ...mapGetters([
      'getCountries',
      'getStylist'
    ]),
    countries () {
      return Vue.$array.keyValue(this.getCountries, 'id', 'name')
    },
    rows () {
      var list = []

      for (var row of this.data) {
        var make = row

        row.order_id = {
          type: 'order',
          order_id: row.id
        }

        make.customer_data = {
          type: 'customer',
          customer: row.customer
        }

        make.age = Math.round(
          ((new Date()).getTime() - (new Date(make.order_date)).getTime()) / (1000 * 60 * 60)
        )

        if (make.priority <= 5) {
          make._always = true
          make._color = 'pink'
        }

        // var id = make.id;

        make.menu = [
          {
            name: 'Comments',
            onClick: record => this.comments(record.id)
          },
          {
            name: 'Pick',
            onClick: record => {
              this.pick(record.id)
            }
          }
        ]

        list.push(make)
      }

      return list.filter(row => {
        return row.locale_id == this.filter_country
      })
    }
  },
  methods: {
    comments (row) {
      if (typeof row === 'object') {
        this.comments_editor = row.id ? row.id : row.ID
      } else {
        this.comments_editor = row
      }
    },
    pick (id) {
      this.picking_id = id
      Vue.api.get('/order/' + id + '/pick/preconditions', {}, {
        before: () => this.soft_loading = true,
        // always: () => this.soft_loading = false,
        callback: data => this.precondition(data)
      })
    },
    precondition (data) {
      this.soft_loading = false
      if (!data.allow_pick) {
        const message = data.message
          ? 'The order cannot be picked. Reason: ' + data.message
          : 'The order cannot be picked'
        alert(message)
        return
      }

      if ((data.message && confirm(data.message + ' Continue?')) || !data.message) {
        Vue.api.post('/order/' + this.picking_id + '/pick', {}, {
          before: () => this.soft_loading = true,
          always: () => this.soft_loading = false,
          callback: data => this.picked(data)
        })
      }
    },
    picked (data) {
      const id = data.id || data.ID
      const key = data.key
      this.$router.push({
        path: '/stylings/process',
        query: {
          id,
          key
        }
      })
    },
    load () {
      Vue.$api.get('/orders/up-for-grabs?country_id=' + this.filter_country +
          'age_comparator=>&age_in_hours=48', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.data = data.items
      this.totalRecords = data.total

      setTimeout(() => this.$refs.table.setFilter({
        age: {
          mode: 'number',
          operator: '>',
          value: 48
        }
      }),
      100
      )
    }
  },
  created () {
    this.filter_country = this.getStylist.locale_id

    this.load()
  }
}
</script>
